import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';
import dropsLoader from '@/mixins/components/drops-loader';
import loadData from '@storm/mixins/load-data';
import EditUser from './edit-user';

export default Vue.component('storm-user-table', {
  template: require('./template.html'),
  name: 'storm-user-table',
  mixins: [loadData],
  computed: {
    ...mapGetters(['stormUsers']),
    filteredUsers() {
      const cleanList = _.map(this.stormUsers, user => ({
        _id: user.Username,
        sub: user.Username,
        email: this.getAttr(user.Attributes, 'email'),
        name: this.getAttr(user.Attributes, 'name'),
        type: this.getAttr(user.Attributes, 'custom:type'),
        status: user.UserStatus,
        created: user.UserCreateDate,
        picture: this.getAttr(user.Attributes, 'custom:pic'),
        attrs: user.Attributes,
        enabled: user.Enabled,
      }));
      const sortOn = this.sortKey || this.cols[5];
      return _.chain(cleanList)
        .thru((t) => {
          if (this.filterKey) {
            return _.reduce(
              t,
              (acc, row) => {
                // only gather the cols the table needs from data
                const e = [];
                _.forEach(this.cols, (c) => {
                  // clean up the values so that the
                  // searchable items are like how
                  // the template is written
                  const col = this.cleanItem(row[c], c, row);
                  e.push(col);
                });
                if (
                  _.filter(e, v =>
                    _(v)
                      .toLower()
                      .includes(this.filterKey.toLowerCase()),
                  ).length
                ) {
                  acc.push(row);
                }
                return acc;
              },
              [],
            );
          }
          return t;
        })
        .sort((a, b) => {
          // We'll sort accending by default and we'll also ignore case
          // since that may confuse non-technical users
          const ascDesc = this.sortMap[sortOn];
          a = _.isString(a[sortOn]) ? _.toLower(a[sortOn]) : a[sortOn]; // eslint-disable-line
          b = _.isString(b[sortOn]) ? _.toLower(b[sortOn]) : b[sortOn]; // eslint-disable-line
          return (a === b ? 0 : a < b ? -1 : 1) * ascDesc; // eslint-disable-line
        })
        .value();
    },
  },
  components: {
    dropsLoader,
    EditUser,
  },
  data() {
    const cols = ['picture', 'email', 'name', 'type', 'status', 'created', 'enabled'];
    const sortMap = _.zipObject(cols, _.fill(Array(cols.length), -1));
    return {
      cols,
      sortMap,
      sortKey: '',
      filterKey: '',
      paginate: ['userlist'],
      users: [],
      view: 'all-users',
      activeUser: {},
    };
  },
  created() {
    this.getStormUsers();
  },
  methods: {
    editUser(user) {
      this.activeUser = user;
      this.view = 'edit-user';
    },
    deleteUser(sub) {
      this.$store.dispatch('removeInternalUser', { sub });
    },
    setSortKey(k) {
      this.sortKey = k;
      // Invert the value for ascDesc
      this.sortMap[k] = this.sortMap[k] * -1;
    },
    onSearch(e) {
      this._debounce(() => {
        this.filterKey = e.target.value;
      }, 250);
    },
    formatTime(stamp) {
      return moment(stamp).format('MM-DD-YYYY');
    },
    highlight(ctx, query, col) {
      const c = this.cleanItem(ctx, col);
      const value = typeof c !== 'string' ? c.toString() : c;
      return value.replace(
        new RegExp(query, 'ig'),
        match => `<span class='editorUi-searchHighlight'>${match}</span>`,
      );
    },
    cleanItem(item, col) {
      let i = item || '--';
      if (col === 'enabled' && i === '--') {
        i = false;
      }
      if (col === 'created' && i !== '--') {
        i = new Date(i);
        i = this.formatTime(i.toISOString());
      }
      return i;
    },
    getAttr(list, type) {
      const attr = _.find(list, { Name: type });
      return attr ? attr.Value : null;
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/settings-modal/storm-users/user-table/index.js